export default "__VITE_ASSET__DsUTDrov__"